<template>
	<div id="ListProductsComponent" class="listProductsComponent text-muted">
		<button @click="getAllProductsLocal(1)" ref="btnGetAllProductsLocal" v-show="false">Buscar Articulos</button>
		<div v-if="searchingProduct" class="text-center">
			Buscando articulos que coincidan con <i>"{{ searchProducts }}"</i>
		</div>
		<div v-else>
			<div v-if="searchProducts != ''">
				<div v-if="listProducts.length == 0" class="text-center">
					No se encontraron articulos con la palabra <i class="text-black">"{{ searchProducts }}"</i>
				</div>
				<div v-else>
					<div class="row list">
						<div v-for="(item, index) in listProducts" :key="index" :class="(display == 'list') ? 'col-12' : 'col-md-3'">
							<div class="border border-muted mb-1">
								<div class="row">
									<div class="text-center" :class="(display == 'list') ? 'col-md-2' : 'col-12'">
										<img class="img pointer"  @click="selectItem(item)" :src="(item.img == null || item.img == '') ? '/img/img-not-found.png' : item.img">
									</div>
									<div class="align-baseline" :class="(display == 'list') ? 'col-md-8' : 'col-12 text-center'">
										<h6 class="p-1"><b>{{ item.name }}</b></h6>
										<div>Cod: {{ item.id }}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import errors from '@/mixins/errors.js'
	import axiosAction from '@/mixins/axiosAction.js'
	import products from '@/mixins/products'

	export default {
		name: 'ListProductsComponent',
		mixins: [axiosAction, errors, mixin, products],
		props: ['search'],
		data () {
			return {
				display: ''
			}
		},
		computed: {
		},
		methods: {
			getAllProductsLocal(page) {
				this.searchProducts = this.search
				this.getAllProducts(page)
			},
			getAllProductsResultLocal(response) {
				if(response.data.success == true) {
					this.$emit('actionGetAll', response.data.data)
				}
			},
			resultAxiosLocal(responseLocal, response) {
				switch(responseLocal) {
					case 'getAllProductsResult': this.getAllProductsResult(response); break;
					default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
				}
			},
			selectItem(item) {
				this.$emit('actionSelectItem', item)
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.listProductsComponent {
	.list {
		.col-md-3 {
			img {
				max-width: 100%;
				height: 200px;
			}
		}
		.col-12 {
			img {
				margin: 5px 0px;
				max-width: 100%;
				max-height: 100px;
			}
		}
	}
}
</style>
